// Feature Documentation: docs/features/refactor-strict-analysis-and-carrier-data.md
import React from 'react';
import { Card, CardHeader, CardBody, Heading, Text, SimpleGrid, Box, Badge } from '@chakra-ui/react';

const CarrierInfoPanel = ({ data }) => {
  if (!data) return null;

  return (
    <Card mb={6} shadow="sm" border="1px solid" borderColor="gray.200">
      <CardHeader bg="blue.50" py={3} borderBottomWidth="1px">
        <Heading size="sm" color="blue.800">Carrier & Payer Information</Heading>
      </CardHeader>
      <CardBody>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
          <Box>
            <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold">Carrier Name</Text>
            <Text fontWeight="medium">{data.carrier_name || 'N/A'}</Text>
          </Box>
          <Box>
            <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold">Payer Type</Text>
            <Text fontWeight="medium">{data.payer_type || 'N/A'}</Text>
          </Box>
          <Box>
            <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold">State</Text>
            <Text fontWeight="medium">
              {data.state_full ? `${data.state_full} ${data.state_abbr ? `(${data.state_abbr})` : ''}` : 'N/A'}
            </Text>
          </Box>
          <Box>
            <Text fontSize="xs" color="gray.500" textTransform="uppercase" fontWeight="bold">Status</Text>
            {data.status ? (
              <Badge colorScheme="blue">{data.status}</Badge>
            ) : (
              <Text fontWeight="medium">N/A</Text>
            )}
          </Box>
        </SimpleGrid>
      </CardBody>
    </Card>
  );
};

export default CarrierInfoPanel;
